<template>
  <div class="resource-library-container" v-bind:class="{ 'pinned': pinned }">
    <div class="resource-library" v-bind:class="{ 'pinned': pinned }">
      <div class="resource-library-body">
        <div class="title-bar">
          <span>Asset Library</span>

          <div class="resource-library-controls">
            <button
              class="btn btn-link btn-sm"
              :title="`${pinned ? 'Unpin' : 'Pin'} asset library`"
              data-entity="producer-assets-togglePinned"
              @click="toggleVisibility"
            >
              <span
                class="fa-thumbtack"
                :class="pinned ? 'fas' : 'far'"
              />
            </button>

            <button
              class="btn btn-link btn-sm"
              title="Refresh asset library"
              data-entity="producer-assets-reloadAll"
              @click="reloadAssetLibrary"
            >
              <span class="fas fa-redo" />
            </button>
          </div>
        </div>

        <div class="source-types">
          <router-link
            :to="{ name: 'themes' }"
            tag="span"
            data-entity="producer-assets-showThemes"
          >
            Themes
          </router-link>

          <router-link
            :to="{ name: 'tagboards' }"
            tag="span"
            data-entity="producer-assets-showTagboards"
          >
            Tagboards
          </router-link>

          <router-link
            v-if="hasPanels"
            :to="{ name: 'smartpanels' }"
            tag="span"
            data-entity="producer-assets-showPanels"
          >
            Panels
          </router-link>

          <router-link
            :to="{ name: 'graphics' }"
            tag="span"
            data-entity="producer-assets-showGraphics"
          >
            Graphics
          </router-link>
        </div>

        <router-view class="loaded" />
      </div>

      <div class="resource-library-title">
        <span>Asset Library</span>
      </div>
    </div>
  </div>
</template>

<script>
import Analytics from '../../../utils/analytics';

export default {
  props: ['pinned'],

  computed: {
    production() {
      return this.$store.state.production.production;
    },

    hasPanels() {
      return this.$store.state.user.has_panels;
    },

    /**
    * Currently open tagboard, if there is one.
    * Pulled from the route params.
    */
    tagboardId() {
      return this.$route.params.tagboard_id;
    },
  },

  methods: {
    /**
    * Reload loaded assets for all tabs.
    * We might want to limit this to the active tab in the future.
    */
    reloadAssetLibrary() {
      // Graphic templates
      this.$store.dispatch('resetTemplates');
      this.$store.dispatch('getTemplates');

      // Themes
      this.$store.dispatch('resetThemes');
      this.$store.dispatch('getThemes');

      // Smart Panels
      this.$store.dispatch('resetPanels');
      this.$store.dispatch('getPanels');

      // Tagboards
      this.$store.dispatch('resetTagboards');
      this.$store.dispatch('getTagboards');

      // Reload currently active tagboard if it's open
      if (this.tagboardId) {
        this.$store.dispatch('clearTagboardPosts', this.tagboardId);
        this.$store.dispatch('getPostsByTagboard', { tagboardId: this.tagboardId });
      }
    },

    toggleVisibility() {
      const isPinned = !this.pinned;

      Analytics.log({
        event: `Producer ${isPinned ? 'Pinned' : 'Unpinned'} Asset Library`,
        fields: {
          production_id: this.production._id,
        },
        ownerId: this.production.owner,
      });

      this.$emit('onPinAssetLibrary', isPinned);
    },
  },
};
</script>
